module.exports = __webpack_public_path__ + "static/media/2-2.a222b6b1.png";